export default "__VITE_ASSET__CXoV1Tgh__"